import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  TextField,
  MenuItem,
  Button,
  FormControl,
  Select,
  Typography,
  FormHelperText,
  InputLabel,
  Breadcrumbs,
  Box,
  Paper,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import "./SelectedBook.css";
import NavBar from "./NavBar";
import api from "../axiosInstance";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { toast } from "react-toastify";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import DeleteIcon from "@mui/icons-material/Delete";
const SelectedBook = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  //const [books, setBooks] = useState([]);
  const [selectedBook, setSelectedBook] = useState({ id: "", title: "" });
  const [unitNumber, setUnitNumber] = useState("");
  const [examQpTitle, setExamQpTitle] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [bookPartType, setBookPartType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [serverResponse, setServerResponse] = useState("");
  const [showServerResponse, setShowServerResponse] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [bookPartTypesList, setBookPartTypesList] = useState([]); // Book Part Type options
  const [isUnitDisabled, setIsUnitDisabled] = useState(false);
  const [tempUnit, setTempUnit] = useState("");
  const [tempFile, setTempFile] = useState(null);
  const [tempExamQpTitle, setTempExamQpTitle] = useState("");
  const [unitFileList, setUnitFileList] = useState([]);

  useEffect(() => {
    // Fetch Books
    api
      .get("/api/v1/books")
      .then((response) => {
        //setBooks(response.data.data);
        const currentBook = response.data.data.find(
          (book) => book.id === parseInt(id),
        );

        setSelectedBook(
          currentBook
            ? { id: currentBook.id, title: currentBook.title }
            : { id: "", title: "" },
        );
      })
      .catch((error) => {
        console.error("Error fetching the book details", error);
      });

    // Fetch Book Part Types (You can skip API call and hardcode if needed)
    // Here, assuming API endpoint like /api/v1/bookPartTypes exists
    api
      .get("/bookPartTypes")
      .then((response) => {
        setBookPartTypesList(response.data.data); // Expected: [{value: "SHORT_QUESTION_ANSWER", label: "Short Answer Questions"}, ...]
      })
      .catch((error) => {
        console.error("Error fetching book part types", error);
        // If backend not ready, use fallback
        setBookPartTypesList([
          { value: "SYLLABUS", label: "Syllabus" },
          { value: "FAQS", label: "FAQs" },
          { value: "MODEL_QP", label: "Model Question Paper" },
          { value: "EXAM_QP", label: "Exam Question Paper" },
          { value: "WEIGHTAGE", label: "Weightage" },
          { value: "QUESTIONANDANSWER", label: "Question & Answers" },
          {
            value: "LMR_SHORT_QUESTION_ANSWER",
            label: "Lmr Short Answer Questions",
          },
          {
            value: "LMR_LONG_QUESTION_ANSWER",
            label: "Lmr Question & Answers",
          },
          { value: "SUMMARY", label: "Summary" },
          { value: "LECTURENOTES", label: "Lecture Notes" },
          { value: "LECTURENOTESSUMMARY", label: "Lecture Notes Summary" },
          {
            value: "LECTURENOTESINTERNALASSESSMENT",
            label: "Lecture Notes Internal Assessment",
          },
          { value: "VIDEOS", label: "Videos" },
          { value: "PDFS", label: "Pdfs" },
          { value: "TIPS_TRICKS", label: "Tips Tricks" },
        ]);
      });
  }, [id]);
  // Define type groups
  const zeroUnitTypes = ["SYLLABUS", "EXAM_QP", "VIDEOS"];
  const oneUnitTypes = [
    "QUESTIONANDANSWER",
    "LECTURENOTES",
    "LECTURENOTESSUMMARY",
    "LECTURENOTESINTERNALASSESSMENT",
    "TIPS_TRICKS",
  ];

  // Auto-set unitNumber when type changes
  useEffect(() => {
    if (zeroUnitTypes.includes(bookPartType)) {
      setUnitNumber("0");
      //setIsUnitDisabled(true);
    } else if (oneUnitTypes.includes(bookPartType)) {
      setUnitNumber("1");
      //setIsUnitDisabled(true);
    } else {
      setUnitNumber("");
      //setIsUnitDisabled(false);
    }
  }, [bookPartType]);

  const validate = () => {
    let tempErrors = {};
    if (!bookPartType) tempErrors.bookPartType = "Book Part Type is required";
    if (unitFileList.length === 0)
      tempErrors.file = "Please add at least one Unit & File";
    // if (!file) tempErrors.file = "Uploaded zip file is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      const fileName = uploadedFile.name.toLowerCase();
      const fileType = uploadedFile.type;

      const allowedExtensions = [
        ".zip",
        ".pdf",
        ".docx",
        ".xls",
        ".xlsx",
        ".csv",
      ];
      const allowedMimeTypes = [
        "application/zip",
        "application/x-zip-compressed",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
        "application/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
        "application/csv",
      ];

      const isAllowedExtension = allowedExtensions.some((ext) =>
        fileName.endsWith(ext),
      );
      const isAllowedMimeType = allowedMimeTypes.includes(fileType);

      if (isAllowedExtension && isAllowedMimeType) {
        setFile(uploadedFile);
      } else {
        toast("Please upload only ZIP, PDF, DOCX, or Excel/CSV files.");

        setFile(null);
      }
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validate()) return;

  //   try {
  //     setIsLoading(true);
  //     const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  //     let uploadedIds = [];
  //     // Loop through all added files
  //     for (let i = 0; i < unitFileList.length; i++) {
  //       const item = unitFileList[i];

  //       const formData = new FormData();
  //       formData.append("bookId", selectedBook.id);
  //       formData.append("bookPartType", bookPartType);
  //       formData.append("unitNumber", item.unit);
  //       formData.append("examQpTitle", item.examQpTitle || "");
  //       formData.append("book", item.file);
  //       const response = await api.post("/parse/processBookPart", formData, {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       });
  //       // console.log(response);
  //       // console.log(response.data.unitIds);
  //       uploadedIds.push(...response.data.unitIds);
  //     }

  //     setServerResponse(
  //       `All files uploaded successfully! Unit IDs: ${uploadedIds.join(", ")}`,
  //     );
  //     setOpenSuccess(true);

  //     // Reset
  //     setUnitFileList([]);
  //     setTempUnit("");
  //     setTempFile(null);
  //     setTempExamQpTitle("");
  //     setErrors({});
  //   } catch (error) {
  //     setServerResponse(
  //       error.response?.data?.errorMessage || "Error while uploading files",
  //     );
  //     setOpenSuccess(true);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setIsLoading(true);

    let uploadedIds = [];
    let results = [];

    try {
      for (let i = 0; i < unitFileList.length; i++) {
        const item = unitFileList[i];

        const formData = new FormData();
        formData.append("bookId", selectedBook.id);
        formData.append("bookPartType", bookPartType);
        formData.append("unitNumber", item.unit);
        formData.append("examQpTitle", item.examQpTitle || "");
        formData.append("book", item.file);

        try {
          console.log(api);

          const response = await api.post("/parse/processBookPart", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          uploadedIds.push(...response.data.unitIds);

          results.push({
            fileName: item.file.name,
            unit: item.unit,
            status: "success",
          });
        } catch (error) {
          results.push({
            fileName: item.file.name,
            unit: item.unit,
            status: "error",
            message:
              error.response?.data?.errorMessage || "Error while uploading",
          });
        }
      }

      // Build message
      const successFiles = results.filter((r) => r.status === "success");
      const failedFiles = results.filter((r) => r.status === "error");

      let message = "";

      if (failedFiles.length > 0) {
        message += "\<b>Failed:</b>";
        failedFiles.forEach((f) => {
          message += `- ${f.fileName} (Unit ${f.unit}) → <b style="color:red">${f.message}</b><br/>`;
        });
      }
      if (successFiles.length > 0) {
        message += "<b>Success:</b>";
        successFiles.forEach((f) => {
          message += `- ${f.fileName} (Unit ${f.unit})`;
        });
      }

      // Final response
      setServerResponse(message);
      setOpenSuccess(true);

      // Reset only if all success (optional)
      const isAllSuccess = results.every((r) => r.status === "success");

      if (isAllSuccess) {
        setUnitFileList([]);
        setTempUnit("");
        setTempFile(null);
        setTempExamQpTitle("");
        setErrors({});
      }
    } catch (error) {
      // Unexpected error (rare case)
      setServerResponse("Something went wrong. Please try again.");
      setOpenSuccess(true);
    } finally {
      setIsLoading(false);
    }
  };
  const isSuccess =
    typeof serverResponse === "string" &&
    serverResponse.includes("<b>Success:</b>") &&
    !serverResponse.includes("<b>Failed:</b>");
  return (
    <div>
      {/* <NavBar /> */}
      {/* {showServerResponse && (
        <div
          className="server-response"
          style={{
            position: "relative",
            padding: "16px",
            border: "1px solid #ccc",
            border: serverResponse?.toLowerCase().includes("successfully")
              ? "1px solid #10af10ff"
              : "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: serverResponse
              ?.toLowerCase()
              .includes("successfully")
              ? "rgba(54, 150, 54, 0.15)"
              : "#ff000012",
          }}
        >
          <Button
            size="small"
            onClick={() => setShowServerResponse(false)}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              minWidth: "30px",
              fontSize: "16px",
              lineHeight: "1",
              padding: "4px",
            }}
          >
            ❌
          </Button>
          <div className="server-response-content">
            <Typography
              variant="body1"
              sx={{
                color: serverResponse?.toLowerCase().includes("successfully")
                  ? "green"
                  : "red",
              }}
            >
              {serverResponse}
            </Typography>
          </div>
        </div>
      )} */}
      <Box sx={{ margin: "20px" }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Book Uploading
          </Typography>
        </Breadcrumbs>
      </Box>
      <Box
        sx={{
          width: "100%",
          maxWidth: { xs: 365, md: 550 },
          mx: "auto",
          mt: 4,
          p: 2,
          mb: 3,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            mb: 3,
            color: "#17479e",
            fontWeight: 550,
            fontSize: "20px",
            textAlign: "Start",
            marginLeft: "16px",
          }}
        >
          Uploading Book
        </Typography>
        <form className="custom-form" onSubmit={handleSubmit}>
          <div className="form-row">
            {/* <label className="form-label">Book Title</label> */}
            <TextField
              label="Book Title"
              value={selectedBook.title}
              InputProps={{ readOnly: true }}
              className="form-input"
            />
          </div>

          <div className="form-row">
            {/* <label className="form-label">Book Part Type</label> */}
            <FormControl className="form-input" error={!!errors.bookPartType}>
              <InputLabel id="discount-type-label">Book Part Type</InputLabel>
              <Select
                label="Book Part Type"
                sx={{ textAlign: "left" }}
                value={bookPartType}
                onChange={(e) => setBookPartType(e.target.value)}
              >
                {bookPartTypesList.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
              {errors.bookPartType && (
                <FormHelperText>{errors.bookPartType}</FormHelperText>
              )}
            </FormControl>
          </div>
          {bookPartType === "EXAM_QP" && (
            <div className="form-row">
              <TextField
                label="Exam QpTitle"
                value={tempExamQpTitle}
                onChange={(e) => setTempExamQpTitle(e.target.value)}
                className="form-input"
              />
            </div>
          )}
          <div className="form-row">
            {/* <label className="form-label">Unit</label> */}
            <TextField
              label="Unit"
              value={tempUnit}
              onChange={(e) => setTempUnit(e.target.value)}
              className="form-input"
              disabled={isUnitDisabled}
            />
          </div>
          <Box sx={{ mt: 2 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                borderStyle: "dashed",
                borderColor: errors.file ? "error.main" : "grey.400",
                bgcolor: "#fafafa",
                textAlign: "center",
              }}
            >
              <Stack spacing={2} alignItems="center">
                <CloudUploadIcon
                  color={errors.file ? "error" : "primary"}
                  fontSize="large"
                />
                <Box sx={{ display: "flex" }}>
                  <Button
                    variant="contained"
                    component="label"
                    color={errors.file ? "error" : "primary"}
                  >
                    Click to Upload Books
                    <input
                      type="file"
                      hidden
                      accept=".zip,.pdf,.docx,.xls,.xlsx,.csv"
                      // onChange={handleFileChange}
                      onChange={(e) => {
                        handleFileChange(e);
                        setTempFile(e.target.files[0]);
                      }}
                    />
                  </Button>
                  <Grid item xs={2}>
                    <Tooltip title="Add Unit & File" placement="right">
                      <IconButton
                        color="success"
                        onClick={() => {
                          if (!tempUnit || !tempFile) return;

                          setUnitFileList([
                            ...unitFileList,
                            {
                              unit: tempUnit,
                              file: tempFile,
                              examQpTitle: tempExamQpTitle,
                            },
                          ]);

                          setTempUnit("");
                          setTempFile(null);
                          setTempExamQpTitle("");
                        }}
                      >
                        <AddToPhotosIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  Accepted formats: .zip, .pdf, .docx and Excel/CSV files.
                </Typography>

                {errors.file && (
                  <Typography color="error" variant="body2">
                    {errors.file}
                  </Typography>
                )}

                {/* {file && (
                  <Typography variant="body2" color="success.main">
                    Selected File: <strong>{file.name}</strong>
                  </Typography>
                )} */}
              </Stack>

              {tempFile && (
                <Typography variant="caption" color="success.main">
                  {tempFile.name}
                </Typography>
              )}
            </Paper>
          </Box>
          <Box
            sx={{
              mt: 2,
            }}
          >
            {unitFileList.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Typography>
                  File: {item.unit} {item.examQpTitle} — {item.file.name}
                  {item.examQpTitle ? ` ` : ""}
                </Typography>

                <IconButton
                  color="error"
                  onClick={() => {
                    const updated = [...unitFileList];
                    updated.splice(index, 1);
                    setUnitFileList(updated);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </Box>

          <div className="selectedbook-button">
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              color="primary"
            >
              Back
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="form-submit"
            >
              {isLoading ? "Loading..." : "Submit"}
            </Button>
          </div>
        </form>
        <Dialog
          open={openSuccess}
          onClose={() => setOpenSuccess(false)}
          PaperProps={{
            sx: {
              borderRadius: 3,
              p: 2,
              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          <DialogTitle sx={{ textAlign: "center", pb: 0 }}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              {isSuccess ? (
                <CheckCircleOutlineIcon
                  sx={{ fontSize: 60, color: "success.main", mb: 1 }}
                />
              ) : (
                <HighlightOffIcon
                  sx={{ fontSize: 60, color: "error.main", mb: 1 }}
                />
              )}
              <Typography variant="h6" fontWeight={600}>
                {isSuccess ? "Success!" : "Error"}
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ textAlign: "left", mt: 1 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              dangerouslySetInnerHTML={{ __html: serverResponse }}
            />
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              color={isSuccess ? "success" : "error"}
              sx={{
                borderRadius: 2,
                px: 4,
                textTransform: "none",
                fontWeight: 600,
              }}
              onClick={() => setOpenSuccess(false)}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
};

export default SelectedBook;
